import { call, put } from "redux-saga/effects";
import { toast } from "react-toastify";
import { updateCategories, } from "../actions";
import axios from "axios";
import Cookies from 'js-cookie'



const requestFetchCategories = () => {
  return axios.request({
    method: "get",
    headers: {
      'Content-Type': 'application/json',
      'Authorization': Cookies.get('token')
    },
    url: `${process.env.REACT_APP_SERVER_URL}/v1/products/get-categories`
  })
}

export function* fetchCategoryFields() {

  try {
    //yield put(showLoader());
    let records = yield call(requestFetchCategories);
    //yield put(hideLoader());
    console.log("response from fetchCategoryFeilds handler: ", records.data)
    yield put(updateCategories(records.data));
    //   toast.success("Category fields fethced successfully.");'

  } catch (error) {
    //console.log("Error :", error);
    console.log("show error", error);
    toast.error("An error occurred while fetching category fields");
  }
}


